import React from 'react';
import { Flex, Typography, Tag } from 'antd';
import { UserOutlined, CalendarOutlined } from '@ant-design/icons';

const CreatorInfo = ({ createdBy, createdAt, variant = 'default' }) => {
  if (!createdBy && !createdAt) return null;

  if (variant === 'compact') {
    return (
      <Flex vertical gap={4}>
        {createdBy && (
          <Typography.Text strong>{createdBy.name}</Typography.Text>
        )}
        {createdBy && createdBy.role && (
          <Tag style={{ height: 18, fontSize: 10, lineHeight: '16px' }}>
            {createdBy.role.replace('_', ' ')}
          </Tag>
        )}
      </Flex>
    );
  }

  if (variant === 'inline') {
    return (
      <Flex align="center" gap={8} wrap="wrap">
        {createdBy && (
          <>
            <Typography.Text type="secondary">Created by</Typography.Text>
            <Typography.Text strong>{createdBy.name}</Typography.Text>
            {createdBy.role && (
              <Tag style={{ height: 18, fontSize: 10, lineHeight: '16px' }}>
                {createdBy.role.replace('_', ' ')}
              </Tag>
            )}
          </>
        )}
        {createdAt && (
          <Typography.Text type="secondary" style={{ marginLeft: 'auto' }}>
            {new Date(createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </Typography.Text>
        )}
      </Flex>
    );
  }

  return (
    <Flex
      align="center"
      gap={16}
      style={{
        padding: 12,
        background: 'var(--colorBgLayout)',
        borderRadius: 8,
        border: '1px solid var(--colorBorder)',
      }}
    >
      {createdBy && (
        <Flex align="center" gap={8} flex={1}>
          <UserOutlined style={{ color: 'var(--colorTextSecondary)' }} />
          <Flex vertical>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              Created by
            </Typography.Text>
            <Typography.Text strong>{createdBy.name}</Typography.Text>
          </Flex>
          {createdBy.role && (
            <Tag color="blue" style={{ marginLeft: 8, textTransform: 'capitalize' }}>
              {createdBy.role.replace('_', ' ')}
            </Tag>
          )}
        </Flex>
      )}
      {createdAt && (
        <Flex align="center" gap={8}>
          <CalendarOutlined style={{ color: 'var(--colorTextSecondary)' }} />
          <Typography.Text type="secondary">
            {new Date(createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Typography.Text>
        </Flex>
      )}
    </Flex>
  );
};

export default CreatorInfo;
